import React from 'react'
import ReactDOMServer from 'react-dom/server'

// Returns the given array with duplicates dropped. "Duplicates" are defined by the optional key function.
function dropDuplicates(array, key = () => {}) {
    const seen = []
    return array.filter(item => {
        const k = key(item)
        if (seen.includes(k)) {
            return false
        }
        seen.push(k)
        return true
    })
}

export const queryParcels = (map, shape) => {
    let features

    // At small scale the 'unselectedParcelLine' and 'selectedParcelLine' layers don't include APNs in the feature
    // properties (in order to save space) so we query 'selection' instead. Why not query 'selection' always?
    // Because selection isn't rendered at high zoom levels (>13).
    if (map.getZoom() >= 13) {
        features = map.queryRenderedFeatures(shape, { layers: ['unselectedParcelLine', 'selectedParcelLine'] })
    } else {
        features = map.queryRenderedFeatures(shape, { layers: ['selection'] })
    }

    // remove features without APNs
    features = features.filter(f => f.properties.parcel_apn !== undefined)

    // remove features with duplicate APNs
    features = dropDuplicates(features, f => f.properties.parcel_apn)

    return features
}

export const generateHatchURI = (color, style, strokeDensity) => {
    const strokeWidth = strokeDensity * 46 // needs to be in between 0 and 46 [64/SQRT(2)]

    const hatchLines = (
        <>
            <line x1="-32" y1="64" x2="64" y2="-32" stroke={color} strokeWidth={strokeWidth} />
            <line x1="0" y1="96" x2="96" y2="0" stroke={color} strokeWidth={strokeWidth} />
        </>
    )

    const crosshatchLines = (
        <>
            <line x1="0" y1="64" x2="64" y2="0" stroke={color} strokeWidth={strokeWidth} />
            <line x1="0" y1="0" x2="64" y2="64" stroke={color} strokeWidth={strokeWidth} />
        </>
    )

    const lines = style === 'simple' ? hatchLines : crosshatchLines

    const svg = (
        <svg xmlns="http://www.w3.org/2000/svg" width="512" height="512">
            <defs>
                <pattern id="hatch" patternUnits="userSpaceOnUse" width="64" height="64">
                    {lines}
                </pattern>
            </defs>
            <rect fill="url(#hatch)" width="100%" height="100%" />
        </svg>
    )

    return `data:image/svg+xml,${ReactDOMServer.renderToString(svg).replaceAll('#', '%23')}`
}

export const generateHatchPattern = (map, id, size, color, style, strokeDensity) => {
    const img = new Image(size, size)

    img.onload = () => {
        if (!map.hasImage(id)) {
            map.addImage(id, img)
        }
    }

    img.crossOrigin = 'Anonymous'
    img.src = generateHatchURI(color, style, strokeDensity)
}
